// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"549":"58b84233","768":"c9d9458c","860":"70bbdd52","955":"37ecbd63","983":"f3702a64"}[chunkId] + ".chunk.css";
};